import { render, staticRenderFns } from "./ObitAdd.vue?vue&type=template&id=8287d1bc&scoped=true"
import script from "./ObitAdd.vue?vue&type=script&lang=js"
export * from "./ObitAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8287d1bc",
  null
  
)

export default component.exports